import { i18n } from 'core/localization';
import { AntSelectOption } from 'controls/react/ant/ant-select/types';

export enum CostValueType {
	Budget = 'BUDGET',
	Estimate = 'ESTIMATE',
	Cost = 'COST',
}

let costTypeDataList: AntSelectOption[];
export function getCostTypeDataList() {
	if (costTypeDataList == null) {
		return [
			{
				label: i18n('Budget'),
				value: 'BUDGET',
			},
			{
				label: i18n('Cost'),
				value: 'COST',
			},
			{
				label: i18n('Estimate'),
				value: 'ESTIMATE',
			},
		];
	}

	return costTypeDataList;
}
